import React from 'react';
import './Zodiacdetail.scss';
import  Globals from '../../api' ;
import { Helmet } from "react-helmet"; 
import ads5 from '../../assets/img/ads5.png';
import Rightbar from "../../components/Rightbar/Rightbar";
// import zdc1 from '../../assets/img/zdc1.png';
// import MustRead from '../../components/MustRead/Mustread';


export default class ZodiacDetail extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            AstroData  : [],
            FaladeshPages : [],
            meta : [] ,
            title : [],
            meta_keywords : [],
            meta_description : [],
            HoroscopeNavigationItems : [],
            HoroscopeDescription : [],
            HoroscopeNavigation : [], 
            Rightbar : [],
            AdData :[]
           
         };
      }
      getRightbar(){
        const url= Globals.Rightbar_api+"/astrology-telugu";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }  
      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].ROS
                    })
                    
                }) 
            }
    componentDidMount() {
        let URI = window.location.pathname ;
        //console.log(URI);
           const url= Globals.language_based_api+URI;
           fetch(url)
           .then((res) => res.json())
           .then((data) => {
             
               this.setState({
                AstroData : data.Contents[2],
                FaladeshPages : data.Contents[2].FaladeshPages,
                HoroscopeNavigationItems : data.Contents[2].HoroscopeNavigator,
                HoroscopeNavigation : data.Contents[2].HoroscopeNavigator.Selected ,
                 meta : data.Meta ,
                 title : data.Title,
                 meta_keywords : data.Meta.keywords.Attributes.content,
                 meta_description : data.Meta.description.Attributes.content
               })
           }) 
           this.getRightbar();
           this.getAds();
         }
    render() {
        let HoroscopeNavigation = this.state.HoroscopeNavigation;
        let HoroscopeNavigationItems  = this.state.HoroscopeNavigationItems;
        let DailyTitle = HoroscopeNavigationItems.DailyTitle;
        let WeeklyTitle = HoroscopeNavigationItems.WeeklyTitle;
        let MonthlyTitle = HoroscopeNavigationItems.MonthlyTitle;
        let YearlyTitle = HoroscopeNavigationItems.YearlyTitle;
        let AstroData = this.state.AstroData;
        let Faladesh = this.state.FaladeshPages;
        const FaladeshItems =   Faladesh.map((item,i)=>{  
            return(
                <li key={i}><a href={item.Link}>{item.Title}</a></li>
            )});

        return (
            <div className="astrology_page">
                {/* <Helmet>
                <title>{this.state.title}</title>
                <meta name="keywords" content={this.state.meta_keywords} />
                <meta name="description" content={this.state.meta_description} />
                </Helmet>    */}
                <div className="container padding15">
                    <div className="row">
                        <div className="col">
                            {/* <ul className="wdbreadcrumb ">
                                <li><a href="#">धर्म-संसार</a></li>
                                <li><a href="#">ज्योतिष</a></li>
                                <li>साप्ताहिक--राशिफल विस्तार</li>
                            </ul> */}
                            <div className="astrology_container m-t-10">

                            <ul className="astro_buttons">
                                    <li className = {(HoroscopeNavigation == "Daily") ? 'daily_rashi active' : 'daily_rashi' }><a href="/astrology-daily-horoscope">{DailyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Weekly") ? 'week_rashi active' : 'week_rashi' }><a href="/astrology-weekly-horoscope">{WeeklyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Monthly") ? 'month_rashi active' : 'month_rashi' }><a href="/astrology-monthly-horoscope">{MonthlyTitle}</a></li>
                                    <li  className = {(HoroscopeNavigation == "Yearly") ? 'year_rashi active' : 'year_rashi' }><a href="/astrology-yearly-horoscope">{YearlyTitle}</a></li>
                                </ul>
                                <div className="astrology_detail_sect">
                                    <div className="ast_d_head">
                                        <span className="ast_d_icon"><img src={"https://hindi.webdunia.com/img/new-zodiac-signs/zdc"+AstroData.RashiID+".png"}/></span>
                                        <h4>{AstroData.RashiName} - {AstroData.FaladeshTitle}</h4>
                                    </div>
                                    <div className="ast_d_content">
                                        <p>{AstroData.Faladesh}</p>
                                    </div>
                                </div>
                                
                                <div className="rashifaladesh_wrap">
                                    <h3 className="rashifald_w_title">{AstroData.Title}</h3>
                                    <ul className="rashifaladesh_list">
                                      {FaladeshItems}
                                    </ul>
                                </div>



                            </div>

                        </div>
                        <div className="col right_side_bar">
                        <Rightbar Rightbar = {this.state.Rightbar} googleAds ={this.state.AdData} />
                            <div className="ads_block m-b-15">
                                {/* <img src={ads5} /> */}
                                </div>
                            {/* <MustRead /> */}
                            <div className="m-b-15"></div>
                            
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}